import { render } from "./AdminCodes.vue?vue&type=template&id=fd372d1a&scoped=true"
import script from "./AdminCodes.vue?vue&type=script&lang=js"
export * from "./AdminCodes.vue?vue&type=script&lang=js"

import "./AdminCodes.vue?vue&type=style&index=0&id=fd372d1a&lang=scss&scoped=true"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd372d1a"]])

export default __exports__